module.exports = __webpack_public_path__ + "static/media/arrow-right-white.337ad716.png";